<script setup>
import ButtonCta from '@/Components/ui/buttons/ButtonCta.vue'
import { goToAndScrollTo } from '@/Composables/common.js'
import { ref } from 'vue'

const hasLoaded = ref(false)

function imageFadeIn() {
	hasLoaded.value = true
}
</script>

<template>
	<section class="container lg:px-6 xl:px-0">
		<div
			class="flex flex-col-reverse lg:rounded-md lg:overflow-hidden sm:flex-row-reverse"
		>
			<div
				class="w-full bg-vivid-white px-6 py-6 md:px-8 md:py-20 lg:py-28 lg:w-1/2"
			>
				<div class="text-4xl leading-tight text-idrive-dark font-bold">
					Rent a car from iDrive Rentals Australia
				</div>
				<div class="comment-font mt-4 space-y-4">
					<p>
						iDrive Rentals is a rental provider in Australia
						offering cost saving car hire with our 5 star service.
						We offer all inclusive pricing of our modern fleet that
						includes small compact cars, large cars, SUVs and luxury
						vehicles. We have a range of fantastic offers so you get
						the best deal and you can add extra drivers, baby seats
						and other optional products to your rental for a
						seamless experience. iDrive Rentals makes car rental
						easy and convenient using our website. You can book a
						car in a matter of minutes!
					</p>
				</div>
				<div
					class="mt-8 flex w-full flex-col items-baseline md:flex-row"
				>
					<ButtonCta
						:is-external="true"
						button-mode="dark"
						@click="goToAndScrollTo('/', '#book-car')"
					>
						<span class="font-bold">Book now</span>
					</ButtonCta>
				</div>
			</div>
			<div class="relative w-full overflow-hidden md:h-auto lg:w-1/2">
				<div class="h-full">
					<img
						class="object-3/4-center relative h-full w-full object-cover md:absolute lg:object-cover transition duration-500"
						:class="hasLoaded ? 'opacity-100' : 'opacity-0'"
						src="/assets/img/img-australia.png"
						loading="lazy"
						@load="imageFadeIn"
					/>
				</div>
			</div>
		</div>
	</section>
</template>
